export {
  CarouselDefaultPagination,
  CarouselInterface,
  CarouselStage,
  UniversalCarousel,
  type CarouselDefaultPaginationProps,
  type ScrollToIndex,
  type CarouselInterfaceContext,
} from '../../compositions/shared/UniversalCarousel';
